import React, { useState } from "react";
import styles from "./SubSectionText.module.css";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import classnames from "classnames";
import Tooltip from "features/Account/modules/Tooltips/Tootips";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { SeeReferenceModal } from "../SeeReferenceModal/SeeReferenceModal";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { LazyLoadWrapper } from "features/Common/LazyLoadWrapper/LazyLoadWrapper";

export const SubSectionText = withComponentLibraryTheme(
  ({ subSectionConfig }) => {
    const isSeeReferenceModalOpen = useAdminPanelStore(
      (state) => state.isSeeReferenceModalOpen
    );
    const setIsSeeReferenceModalOpen = useAdminPanelStore(
      (state) => state.setIsSeeReferenceModalOpen
    );
    const isDesktop = useDesktopMediaQuery();
    const [openTooltipId, setOpenTooltipId] = useState(null);
    const {
      title,
      description,
      classes,
      value,
      seeReferenceConfig = null,
      key = "",
    } = subSectionConfig;

    const descriptionText = (
      <>
        {description}
        &nbsp;
        {seeReferenceConfig && (
          <span
            className="tw-text-[#493AB1] tw-cursor-pointer"
            onClick={() => setIsSeeReferenceModalOpen(seeReferenceConfig)}
          >
            See reference
          </span>
        )}
      </>
    );

    return (
      <div
        className={classnames(
          styles.mainWrapper,
          value && classes?.subSectionTextMainWrapperEnabledStyle
        )}
      >
        <div className={styles.titleWrapper}>
          <span className={styles.title}>{title}</span>
          {!isDesktop && (
            <Tooltip
              id={description}
              open={openTooltipId === description}
              setOpenTooltipId={setOpenTooltipId}
              displayTitle={descriptionText}
            />
          )}
        </div>
        <div className={styles.description}>{descriptionText}</div>
        <LazyLoadWrapper
          loadingCondition={
            isSeeReferenceModalOpen && seeReferenceConfig?.id === key
          }
        >
          <SeeReferenceModal />
        </LazyLoadWrapper>
      </div>
    );
  }
);
